module.exports = __webpack_public_path__ + "img/map.a1a9748e.png";